﻿import React, { useState, useCallback, useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { StandardReference } from '../../models/Standards/standard-reference';
import { StandardReferenceLot } from '../../models/standard-reference-lot';
import { ManufacturerTypes, Entities, ModalMessageType } from '../../models/enums';
import { LookupItem } from '../../models/lookup-item';
import { CrudFunctions } from '../../utilities/crud-functions';
import { ItemBasicInformation } from '../../models/item-basic-information';
import { ToastProps } from '../../models/toast-props';
import { AuditProps } from '../../models/audit-props';
import ItemBasicInformationDialog from '../ItemBasicInformationDialog';
import AuditHistoryComponent from '../AuditHistoryComponent';
import { DocumentationConstants } from '../../store/documentation-constants';
import { ModalMetadata } from '../../models/modal-metadata';
import GlobalDialog from '../Modal/GlobalDialog';
import TicketLogEntryForm from '../TicketLogEntryForm';
import DmaFooter from '../DmaFooter';

import DataGrid, {
    Column,
    Selection,
    FilterRow,
    Popup,
    Paging,
    Pager,
    Scrolling,
    Toolbar,
    Item as ToolbarItem,
    Editing,
    Form,
    LoadPanel as DataGridLoadPanel,
    Button as ColumnButton,
    HeaderFilter,
    SearchPanel
} from 'devextreme-react/data-grid';

import { Item } from 'devextreme-react/form';
import { Popup as DialogPopup } from 'devextreme-react/popup';
import { SelectBox } from 'devextreme-react';
import { Button } from 'devextreme-react/button';
import { Toast } from 'devextreme-react/toast';

let key = 0;

export default function StandardsMaintenance() {
    const [standardReferences, setStandardReferences] =
        useState<StandardReference[]>();

    const [standardReferencePreviousLots, setStandardReferencePreviousLots] =
        useState<StandardReferenceLot[]>();

    const [selectedStandardReference, setSelectedStandardReference] =
        useState<StandardReference>();

    const [uspRefStandards, setUspRefStandards] =
        useState<StandardReference[]>();

    const [selectedUspRefStandard, setSelectedUspRefStandard] =
        useState<StandardReference>();

    const [uspRefStandardPreviousLots, setUspRefStandardPreviousLots] =
        useState<StandardReferenceLot[]>();

   const [epRefStandards, setEpRefStandards] =
       useState<StandardReference[]>();

    const [epSelectedRefStandard, setSelectedEpRefStandard] =
        useState<StandardReference>();

    const [epRefStandardPreviousLots, setEpRefStandardPreviousLots] =
        useState<StandardReferenceLot[]>();

    const [standardManufacturers, setStandardManufacturers] =
        useState<LookupItem[]>();

    const [selectedStandardManufacturer, setSelectedStandardManufacturer] =
        useState<LookupItem>();

    const [catalogNumberFilter, setCatalogNumberFilter] =
        useState<string>();

    const [lotNumberFilter, setLotNumberFilter] =
        useState<string>();

    const [filteredDataComplete, setFilteredDataComplete] =
        useState<boolean>();

    const [importedStandardReference, setImportedStandardReference] =
        useState<StandardReference>();

    const [auditInformationDialogVisible, setAuditInformationDialogVisible] =
        useState<boolean>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [toastProps, setToastProps] =
        useState<ToastProps>();

    const [auditProps, setAuditProps] =
        useState<AuditProps>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    const [ticketLogEntryDialogVisible, setTicketLogEntryDialogVisible] =
        useState<boolean>();

    const onSelectedStandardManufacturerChanged = useCallback((v) => {
        setSelectedStandardManufacturer(v);
    }, []);

    const parts = window.location.href.split('/');
    let standardId;

    if (parts && !filteredDataComplete) {
        const lastPart = parts[parts.length - 1];

        if (lastPart && lastPart.toLowerCase() !== "standardsmaintenance") {
            standardId = lastPart;
            filterDataFromUrl();
        }
    }

    useEffect(() => {
        getStandardsManufacturers();
        initUiSettings();
    }, []);

    key++;

    return (

        <div className="pw-content">
            <div className="lq-title-bar">
                <div className="lq-main-title">Standards Maintenance {filteredDataComplete ? "(filtered)" : ''}</div>
                <div className="title-bar-spacer" />
                <div className="save-toolbar">
                    <div>
                        <Button className="title-bar-button"
                            text="" icon="tel" type="normal"
                            hint="report issue"
                            onClick={showTicketLogEntryDialog} />
                    </div>
                    <div>
                        <NavLink to={`/documentation/${DocumentationConstants.StandardsForm}`}
                            className="pw-right-align-content" target="_blank" rel="noopener noreferrer">
                            <Button className="title-bar-button pw-orange"
                                text="" icon="help" type="normal"
                                hint="help and documentation" />
                        </NavLink>
                    </div>
                    <div>
                        <Button className="title-bar-button"
                            text="" icon="arrowleft" type="normal"
                            hint="go back"
                            onClick={goBack} />
                    </div>
                </div>
            </div>

            <div>
                <div id="tab-buttons-panel" className="tab-buttons-container">
                    <div id="mainPanelButton" className="tab-button" onClick={onPanelButtonClick}>Main</div>
                    <div id="uspPanelButton" className="tab-button" onClick={onPanelButtonClick}>USP</div>
                    <div id="epPanelButton" className="tab-button" onClick={onPanelButtonClick}>EP</div>
                </div>

                <div id="mainPanel">
                    <div className="pw-comp-row">
                        <div className="pw-form-unit pw-comp-20">
                            <label className="textbox-label">Manufacturers</label>
                            <SelectBox id="manufacturersSelectBox"
                                placeholder='manufacturer'
                                displayExpr='description'
                                dataSource={standardManufacturers ?
                                    standardManufacturers : []}
                                onValueChange={onSelectedStandardManufacturerChanged}
                                value={selectedStandardManufacturer ?
                                    selectedStandardManufacturer : null} />
                        </div>
                        <div>
                            <Button id="refreshStandardsButton" className="pw-row-button-15" height={'1.6rem'}
                                type="success" text="" icon="refresh" onClick={refreshStandards} />
                        </div>

                    </div>

                    {/*
                        <div className="pw-comp-row pw-margin-left-05 pw-margin-bottom-05">
                            <Button id="parseCofADocumentButton" className="pw-row-button-08" height={'1.6rem'}
                                type="success" text="Parse COA Document" onClick={parseCofADocument} />

                            <Button id="parseCofAButton" className="pw-margin-left-05 pw-row-button-08" height={'1.6rem'}
                                type="success" text="Parse COA from Website" onClick={onParseCofAClick} />
                        </div>
                        */}

                    <div className="pw-comp-row pw-margin-top-05">
                        <DataGrid id="standardReferencesDataGrid"
                            width="100%" height="24rem"
                            dataSource={standardReferences ? standardReferences : []}
                            onSelectionChanged={standardReferenceSelectionChanged}
                            onRowValidating={onStandardReferenceValidating}
                            onRowRemoving={onStandardReferenceRowDeleting}
                            onInitNewRow={onInitNewStandardReferenceRow}
                            wordWrapEnabled={true}
                            allowColumnResizing={true}
                            columnResizingMode='nextColumn'
                            showBorders={true}>

                            <DataGridLoadPanel enabled={true} />
                            <Selection mode={'single'} />
                            <Paging enabled={false} />
                            <Pager visible={false} />
                            <HeaderFilter visible={true} />
                            <FilterRow visible={true} />
                            <SearchPanel visible={true} />

                            <Column type="buttons" width='6rem' >
                                <ColumnButton name="edit" />
                                <ColumnButton name="delete" />
                                <ColumnButton hint="audit information" icon="clock"
                                    onClick={showStandardReferenceAuditDialog} />
                                <ColumnButton hint="information" icon="info"
                                    onClick={onStandardReferenceInformationButtonClicked} />
                            </Column>

                            <Column dataField='manufacturerName' caption="Manufacturer" dataType="string" width='12rem' />
                            <Column dataField='catalogNumber' dataType="string" width='12rem' />
                            <Column dataField='productName' dataType="string" width='12rem' />
                            <Column dataField='longName' dataType="string" width='12rem' />
                            <Column dataField='casNumber' dataType="string" caption='CAS #' width='6rem' />

                            <Column name="bc1" width="4rem" cssClass="table-vertical-align"
                                cellRender={catalogReferenceCellRender} />

                            <Column dataField='lotNumber' dataType="string" width='6rem' />
                            <Column dataField='currentLotExpiration' dataType="date" width='6rem' />

                            {/*
                            <Column dataField='previousLotNumber' dataType="string" width='6rem' />
                            <Column dataField='previousLotDateExpired' dataType="date" width='6rem' />

                            <Column dataField='sampleSizeString' dataType="string"
                                caption="Sample Size" width='6rem' />

                            <Column dataField='quantity' dataType="number" width='7rem' />
                            */}

                            <Column />

                            <Toolbar>
                                <ToolbarItem location='before'>
                                    <div className="pw-datagrid-toolbar-template">
                                        <div className="pw-datagrid-toobar-title">Standard References</div>
                                    </div>
                                </ToolbarItem>
                                {/*
                                <ToolbarItem location='after'>
                                    <Button icon="upload" hint="Import from Excel"
                                        width='1.9rem' onClick={uploadStandardReferencesFromExcel} />
                                </ToolbarItem>
                                */}
                                <ToolbarItem name="addRowButton" location="after" />
                                <ToolbarItem name="searchPanel" location='after' />
                            </Toolbar>

                            <Editing
                                mode="popup"
                                useIcons={true}
                                allowAdding={true}
                                allowUpdating={true}
                                allowDeleting={true}>

                                <Popup wrapperAttr={{ id: 'editStandardReferencesPopup' }} title="Edit Standard Reference"
                                    hideOnOutsideClick={false} showTitle={true} width="50rem" height="30rem" />
                                <Form>
                                    <Item dataField="catalogNumber" />
                                    <Item dataField="casNumber" caption="CAS #" />
                                    <Item dataField="productName" colSpan={2} />
                                    <Item dataField="longName" colSpan={2} />
                                    <Item dataField="lotNumber" />
                                    <Item dataField="currentLotExpiration" />
                                    <Item dataField="previousLotNumber" />
                                    <Item dataField="previousLotDateExpired" />
                                    <Item dataField="sampleSizeString" caption="Sample Size" />
                                    <Item dataField="quantity" />
                                </Form>
                            </Editing>

                        </DataGrid>
                    </div>

                    <DataGrid id="standardsPreviousLotsDataGrid"
                        width="100%" height="12rem"
                        dataSource={standardReferencePreviousLots ?
                            standardReferencePreviousLots : []}
                        onRowValidating={onStandardReferencePreviousLotValidating}
                        onRowRemoving={onStandardReferencePreviousLotRowDeleting}
                        onInitNewRow={onInitNewPreviousLotRow}
                        wordWrapEnabled={true}
                        allowColumnResizing={true}
                        columnResizingMode='nextColumn'
                        showBorders={true}>

                        <DataGridLoadPanel enabled={true} />
                        <Selection mode='single' />
                        <Scrolling showScrollbar='always' rowRenderingMode='virtual' />
                        <Paging enabled={false} />

                        <Column type="buttons" width='7rem' >
                            <ColumnButton name="edit" />
                            <ColumnButton name="delete" />
                        </Column>

                        <Column dataField='lotName' dataType="string" width='6rem' />
                        <Column dataField='lotExpiration' dataType="date" width='6rem' />

                        <Column dataField='sampleSizeString' dataType="string"
                            caption="Sample Size" width='6rem' />

                        <Column dataField='quantity' dataType="number" width='7rem' />
                        <Column />

                        <Toolbar>
                            <ToolbarItem location='before'>
                                <div className="pw-datagrid-toolbar-template">
                                    <div className="pw-datagrid-toobar-title">Standard Previous Lots</div>
                                </div>
                            </ToolbarItem>
                            <ToolbarItem name="addRowButton" location="after" />
                        </Toolbar>

                        <Editing
                            mode="popup"
                            useIcons={true}
                            allowAdding={true}
                            allowUpdating={true}
                            allowDeleting={true}>

                            <Popup title="Edit Standard Previous Lot"
                                hideOnOutsideClick={false} showTitle={true} width="50rem" height="30rem" />
                            <Form>
                                <Item dataField="lotName" />
                                <Item dataField="lotExpiration" />
                                <Item dataField="sampleSizeString" caption="Sample Size" />
                                <Item dataField="quantity" />
                            </Form>
                        </Editing>
                    </DataGrid>

                    <DmaFooter />
                </div>

                <div id="uspPanel">
                    <div className="pw-comp-row">
                        <Button id="getUspDataButton" className="pw-row-button-08" height={'1.6rem'}
                            type="success" text="Get USP Data" icon="refresh" onClick={getUspData} />
                    </div>

                    <DataGrid id="uspDataGrid"
                        width="100%" height="24rem"
                        dataSource={uspRefStandards ?
                            uspRefStandards : []}
                        onSelectionChanged={uspStandardReferenceSelectionChanged}
                        onRowValidating={onUspStandardReferenceValidating}
                        onRowRemoving={onStandardReferenceRowDeleting}
                        onInitNewRow={onUspInitNewStandardReferenceRow}
                        wordWrapEnabled={true}
                        allowColumnResizing={true}
                        columnResizingMode='nextColumn'
                        showBorders={true}>

                        <DataGridLoadPanel enabled={true} />
                        <Selection mode={'single'} />
                        <Scrolling showScrollbar='always' rowRenderingMode='virtual' />
                        <Paging enabled={true} defaultPageSize={50} />
                        <Pager visible={true} showInfo={true}
                            displayMode="full"
                            showNavigationButtons={true}
                            allowedPageSizes={[50, 100, "all"]} />
                        <HeaderFilter visible={true} />
                        <FilterRow visible={true} />
                        <SearchPanel visible={true} />

                        <Column type="buttons" width='7rem' >
                            <ColumnButton name="edit" />
                            <ColumnButton name="delete" />
                            <ColumnButton hint="audit information" icon="clock"
                                onClick={showStandardReferenceAuditDialog} />
                            <ColumnButton hint="information" icon="info"
                                onClick={onStandardReferenceInformationButtonClicked} />
                        </Column>

                        <Column dataField='manufacturerName' caption="Manufacturer" dataType="string" width='12rem' />
                        <Column dataField='catalogNumber' dataType="string" width='12rem' />
                        <Column dataField='productName' dataType="string" width='12rem' />
                        <Column dataField='longName' dataType="string" width='12rem' />
                        <Column dataField='casNumber' dataType="string" caption='CAS #' width='6rem' />

                        <Column name="bc1" width="4rem" cssClass="table-vertical-align"
                            cellRender={catalogReferenceCellRender} />

                        {/*
                                    <ColumnButton hint="standards lookup" icon="globe"
                                        onClick={onGotoStandardCofAClick} />
                                </Column>
                                */}

                        <Column dataField='lotNumber' dataType="string" width='6rem' />
                        <Column dataField='currentLotExpiration' dataType="date" width='6rem' />
                        {/*
                        <Column dataField='previousLotNumber' dataType="string" width='6rem' />
                        <Column dataField='previousLotDateExpired' dataType="date" width='6rem' />

                        <Column dataField='sampleSizeString' dataType="string"
                            caption="Sample Size" width='6rem' />
                       
                        <Column dataField='quantity' dataType="number" width='7rem' />
                        */}

                        <Column />

                        <Toolbar>
                            <ToolbarItem location='before'>
                                <div className="pw-datagrid-toolbar-template">
                                    <div className="pw-datagrid-toobar-title">USP Standard References</div>
                                </div>
                            </ToolbarItem>

                            {/*
                            <ToolbarItem location='after'>
                                <Button icon="upload" hint="Import from Excel"
                                    width='1.9rem' onClick={uploadStandardReferencesFromExcel} />
                            </ToolbarItem>
                            */}

                            <ToolbarItem name="addRowButton" location="after" />
                            <ToolbarItem name="searchPanel" location='after' />
                        </Toolbar>

                        <Editing
                            mode="popup"
                            useIcons={true}
                            allowAdding={true}
                            allowUpdating={true}
                            allowDeleting={true}>

                            <Popup wrapperAttr={{ id: 'editUspStandardReferencesPopup' }} title="Edit USP Standard Reference"
                                hideOnOutsideClick={false} showTitle={true} width="50rem" height="30rem" />
                            <Form>
                                <Item dataField="catalogNumber" />
                                <Item dataField="casNumber" caption="CAS #" />
                                <Item dataField="productName" colSpan={2} />
                                <Item dataField="longName" colSpan={2} />
                                <Item dataField="lotNumber" />
                                <Item dataField="currentLotExpiration" />
                                <Item dataField="previousLotNumber" />
                                <Item dataField="previousLotDateExpired" />
                                <Item dataField="sampleSizeString" caption="Sample Size" />
                                {/*
                                <Item dataField="sampleSize" />
                                <Item dataField="sampleSizeUom" />
                                */}
                                <Item dataField="quantity" />
                            </Form>
                        </Editing>

                    </DataGrid>

                    <DataGrid id="uspPreviousLotsDataGrid"
                        width="100%" height="12rem"
                        dataSource={uspRefStandardPreviousLots ?
                            uspRefStandardPreviousLots : []}
                        onRowValidating={onUspStandardReferencePreviousLotValidating}
                        onRowRemoving={onUspStandardReferencePreviousLotRowDeleting}
                        onInitNewRow={onUspInitNewPreviousLotRow}
                        wordWrapEnabled={true}
                        allowColumnResizing={true}
                        columnResizingMode='nextColumn'
                        showBorders={true}>

                        <DataGridLoadPanel enabled={true} />
                        <Selection mode='single' />
                        <Scrolling showScrollbar='always' rowRenderingMode='virtual' />
                        <Paging enabled={false} />

                        <Column type="buttons" width='7rem' >
                            <ColumnButton name="edit" />
                            <ColumnButton name="delete" />
                        </Column>

                        <Column dataField='lotName' dataType="string" width='6rem' />
                        <Column dataField='lotExpiration' dataType="date" width='6rem' />

                        <Column dataField='sampleSizeString' dataType="string"
                            caption="Sample Size" width='6rem' />

                        <Column dataField='quantity' dataType="number" width='7rem' />
                        <Column />

                        <Toolbar>
                            <ToolbarItem location='before'>
                                <div className="pw-datagrid-toolbar-template">
                                    <div className="pw-datagrid-toobar-title">USP Standard Previous Lots</div>
                                </div>
                            </ToolbarItem>
                            <ToolbarItem name="addRowButton" location="after" />
                        </Toolbar>

                        <Editing
                            mode="popup"
                            useIcons={true}
                            allowAdding={true}
                            allowUpdating={true}
                            allowDeleting={true}>

                            <Popup title="Edit USP Standard Previous Lot"
                                hideOnOutsideClick={false} showTitle={true} width="50rem" height="30rem" />
                            <Form>
                                <Item dataField="lotName" />
                                <Item dataField="lotExpiration" />
                                <Item dataField="sampleSizeString" caption="Sample Size" />
                                <Item dataField="quantity" />
                            </Form>
                        </Editing>
                    </DataGrid>

                    <DmaFooter />
                </div>

                <div id="epPanel">
                    <div className="pw-comp-row">
                        <Button id="getEpDataButton" className="pw-row-button-08" height={'1.6rem'}
                            type="success" text="Get EP Data" icon="refresh" onClick={getEpData} />
                    </div>

                    <DataGrid id="epDataGrid"
                        width="100%" height="24rem"
                        dataSource={epRefStandards ?
                            epRefStandards : []}
                        onSelectionChanged={epStandardReferenceSelectionChanged}
                        onRowValidating={onEpStandardReferenceValidating}
                        onRowRemoving={onStandardReferenceRowDeleting}
                        onInitNewRow={onEpInitNewStandardReferenceRow}
                        wordWrapEnabled={true}
                        allowColumnResizing={true}
                        columnResizingMode='nextColumn'
                        showBorders={true}>

                        <DataGridLoadPanel enabled={true} />
                        <Selection mode={'single'} />
                        <HeaderFilter visible={true} />
                        <FilterRow visible={true} />
                        <SearchPanel visible={true} />
                        <Scrolling showScrollbar='always' rowRenderingMode='virtual' />
                        <Paging enabled={true} defaultPageSize={50} />
                        <Pager visible={true} showInfo={true}
                            displayMode="full"
                            showNavigationButtons={true}
                            allowedPageSizes={[50, 100, "all"]} />

                        <Column type="buttons" width='7rem' >
                            <ColumnButton name="edit" />
                            <ColumnButton name="delete" />
                            <ColumnButton hint="audit information" icon="clock"
                                onClick={showStandardReferenceAuditDialog} />
                            <ColumnButton hint="information" icon="info"
                                onClick={onStandardReferenceInformationButtonClicked} />
                        </Column>

                        <Column dataField='manufacturerName' caption="Manufacturer" dataType="string" width='12rem' />
                        <Column dataField='catalogNumber' dataType="string" width='12rem' />
                        <Column dataField='productName' dataType="string" width='12rem' />
                        <Column dataField='longName' dataType="string" width='12rem' />
                        <Column dataField='casNumber' dataType="string" caption='CAS #' width='6rem' />

                        <Column name="bc1" width="4rem" cssClass="table-vertical-align"
                            cellRender={catalogReferenceCellRender} />

                        {/*
                                    <ColumnButton hint="standards lookup" icon="globe"
                                        onClick={onGotoStandardCofAClick} />
                                </Column>
                                */}

                        <Column dataField='lotName' dataType="string" width='6rem' />
                        <Column dataField='lotExpiration' dataType="date" width='6rem' />

                        {/*
                        <Column dataField='previousLotNumber' dataType="string" width='6rem' />
                        <Column dataField='previousLotDateExpired' dataType="date" width='6rem' />

                        <Column dataField='sampleSizeString' dataType="string"
                            caption="Sample Size" width='6rem' />
                        
                        <Column dataField='sampleSize' dataType="number" width='6rem' />
                        <Column dataField='sampleSizeUomString' width='5rem' caption='UOM' />
                        

                        <Column dataField='quantity' dataType="number" width='7rem' />
                        */}
                        <Column />

                        <Toolbar>
                            <ToolbarItem location='before'>
                                <div className="pw-datagrid-toolbar-template">
                                    <div className="pw-datagrid-toobar-title">EP Standard References</div>
                                </div>
                            </ToolbarItem>
                            {/*
                            <ToolbarItem location='after'>
                                <Button icon="upload" hint="Import from Excel"
                                    width='1.9rem' onClick={uploadStandardReferencesFromExcel} />
                            </ToolbarItem>
                            */}

                            <ToolbarItem name="addRowButton" location="after" />
                            <ToolbarItem name="searchPanel" location='after' />
                        </Toolbar>

                        <Editing
                            mode="popup"
                            useIcons={true}
                            allowAdding={true}
                            allowUpdating={true}
                            allowDeleting={true}>

                            <Popup title="Edit EP Standard Reference"
                                hideOnOutsideClick={false} showTitle={true} width="50rem" height="30rem" />
                            <Form>
                                <Item dataField="catalogNumber" />
                                <Item dataField="casNumber" caption="CAS #" />
                                <Item dataField="productName" colSpan={2} />
                                <Item dataField="longName" colSpan={2} />
                                <Item dataField="lotName" />
                                <Item dataField="lotExpiration" />
                            </Form>
                        </Editing>
                    </DataGrid>

                    <DataGrid id="epPreviousLotsDataGrid"
                        width="100%" height="12rem"
                        dataSource={epRefStandardPreviousLots ?
                            epRefStandardPreviousLots : []}
                        onRowValidating={onEpStandardReferencePreviousLotValidating}
                        onRowRemoving={onEpStandardReferencePreviousLotRowDeleting}
                        onInitNewRow={onEpInitNewPreviousLotRow}
                        wordWrapEnabled={true}
                        allowColumnResizing={true}
                        columnResizingMode='nextColumn'
                        showBorders={true}>

                        <DataGridLoadPanel enabled={true} />
                        <Selection mode='single' />
                        <Scrolling showScrollbar='always' rowRenderingMode='virtual' />
                        <Paging enabled={false} />

                        <Column type="buttons" width='7rem' >
                            <ColumnButton name="edit" />
                            <ColumnButton name="delete" />
                        </Column>

                        <Column dataField='lotName' dataType="string" width='6rem' />
                        <Column dataField='lotExpiration' dataType="date" width='6rem' />

                        <Column dataField='sampleSizeString' dataType="string"
                            caption="Sample Size" width='6rem' />

                        <Column dataField='quantity' dataType="number" width='7rem' />
                        <Column />

                        <Toolbar>
                            <ToolbarItem location='before'>
                                <div className="pw-datagrid-toolbar-template">
                                    <div className="pw-datagrid-toobar-title">EP Standard Previous Lots</div>
                                </div>
                            </ToolbarItem>
                            <ToolbarItem name="addRowButton" location="after" />
                        </Toolbar>

                        <Editing
                            mode="popup"
                            useIcons={true}
                            allowAdding={true}
                            allowUpdating={true}
                            allowDeleting={true}>

                            <Popup title="Edit EP Standard Previous Lot"
                                hideOnOutsideClick={false} showTitle={true} width="50rem" height="30rem" />
                            <Form>
                                <Item dataField="lotName" />
                                <Item dataField="lotExpiration" />
                                <Item dataField="sampleSizeString" caption="Sample Size" />
                                <Item dataField="quantity" />
                            </Form>
                        </Editing>
                    </DataGrid>

                    <DmaFooter />
                </div>
            </div>

            {toastProps && toastProps.visible &&
                <Toast
                    visible={toastProps.visible}
                    message={toastProps.message}
                    type={toastProps.toastType}
                    onHiding={onToastHiding}
                    displayTime={600} />
            }

            {auditInformationDialogVisible &&
                <DialogPopup visible={auditInformationDialogVisible}
                    onHiding={hideAuditInformationDialog}
                    title="Audit History"
                    minWidth={'50em'}
                    minHeight={'32em'}
                    hideOnOutsideClick={false}
                    dragEnabled={true}
                    resizeEnabled={true}>
                    <AuditHistoryComponent entityNumber={auditProps && auditProps.entity ?
                        auditProps.entity : undefined}
                        key={`AuditHistory${key}`}
                        childData={auditProps && auditProps.informationShowChildData ?
                            auditProps.informationShowChildData : undefined}
                        rowPointer={auditProps && auditProps.rowPointer ?
                            auditProps.rowPointer : undefined} />
                </DialogPopup>
            }

            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width={'25rem'}
                    height={'21rem'}
                    hideOnOutsideClick={false}
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

            {ticketLogEntryDialogVisible &&
                <DialogPopup visible={ticketLogEntryDialogVisible}
                    onHiding={hideTicketLogEntryDialog}
                    title="Ticket Log Entry"
                    width={'55rem'}
                    height={'45rem'}
                    dragEnabled={true}
                    resizeEnabled={true}>
                    <TicketLogEntryForm formName="Raw Materials" contextData={selectedStandardReference}
                        onCancel={hideTicketLogEntryDialog}
                        onComplete={hideTicketLogEntryDialog}
                        key={`TLE${key}`} />
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

            {/* }
            <input type="file"
                id="fileInputElement"
                accept=".xlsx"
                className="file-picker-input"
                value=""
                onChange={onFileLoaderChange} />
                */}

        </div>
    );

    function standardReferenceSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            const standard = e.selectedRowsData[0];
            setSelectedStandardReference(standard);

            getStandardReferencePreviousLotsByStandardId(standard.standardId, ManufacturerTypes.UNKNOWN);
        }
    }

    function uspStandardReferenceSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            const standard = e.selectedRowsData[0];
            setSelectedUspRefStandard(standard);

            getStandardReferencePreviousLotsByStandardId(standard.standardId, ManufacturerTypes.USP);
        }
    }

    function epStandardReferenceSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            const standard = e.selectedRowsData[0];
            setSelectedEpRefStandard(standard);

            getStandardReferencePreviousLotsByStandardId(standard.standardId, ManufacturerTypes.EP);
        }
    }

    /*
    function uploadStandardReferencesFromExcel() {
        const fileElem = document.getElementById("fileInputElement") as HTMLInputElement;

        if (fileElem) {
            fileElem.click();
        }
    }
    */

    function refreshStandards() {
        if (selectedStandardManufacturer) {
            getStandardReferencesByManufacturerId(selectedStandardManufacturer.id);
        }
    }

    function getUspData() {
        getStandardReferencesByManufacturerId(ManufacturerTypes.USP);
    }

    function getEpData() {
        getStandardReferencesByManufacturerId(ManufacturerTypes.EP);
    }

    function onInitNewStandardReferenceRow(e: any) {
        let newStandardReference: StandardReference = {
            manufacturerId: selectedStandardManufacturer.id,
            manufacturerName: selectedStandardManufacturer.name
        };

        e.data = newStandardReference;
    }

    function onUspInitNewStandardReferenceRow(e: any) {
        let newStandardReference: StandardReference = {
            manufacturerId: ManufacturerTypes.USP,
            manufacturerName: "USP"
        };

        e.data = newStandardReference;
    }

    function onEpInitNewStandardReferenceRow(e: any) {
        let newStandardReference: StandardReference = {
            manufacturerId: ManufacturerTypes.EP,
            manufacturerName: "EP"
        };

        e.data = newStandardReference;
    }

    function onInitNewPreviousLotRow(e: any) {
        /*
        let newStandardReference: StandardReference = {
            manufacturerId: ManufacturerTypes.EP,
            manufacturerName: "EP"
        };

        e.data = newStandardReference;
        */
    }

    function onUspInitNewPreviousLotRow(e: any) {
        /*
        let newStandardReference: StandardReference = {
            manufacturerId: ManufacturerTypes.EP,
            manufacturerName: "EP"
        };

        e.data = newStandardReference;
        */
    }

    function onEpInitNewPreviousLotRow(e: any) {
        /*
        let newStandardReference: StandardReference = {
            manufacturerId: ManufacturerTypes.EP,
            manufacturerName: "EP"
        };

        e.data = newStandardReference;
        */
    }

    async function onStandardReferenceValidating(e: any) {
        if (e.oldData) {
            let stdRef = e.oldData as StandardReference;

            if (stdRef) {
                let updatedStandardReference = { ...stdRef, ...e.newData };
                updateStandardReference(updatedStandardReference)
                    .then(() => {
                        showToast("Standard reference updated", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Standard Reference");
                    });
            }
        }
        else {
            if (e.newData) {
                let stdRef = e.newData as StandardReference;

                if (stdRef) {
                    await insertStandardReference(stdRef)
                        .then(data => {
                            showToast("Standard reference saved", "success");

                            if (selectedStandardManufacturer)
                                getStandardReferencesByManufacturerId(selectedStandardManufacturer.id);
                        })
                        .catch((res) => {
                            showMessage(res, ModalMessageType.Error, "Error Inserting Standard Reference");
                        });
                }
            }
        }
    }

    async function onUspStandardReferenceValidating(e: any) {
        if (e.oldData) {
            let stdRef = e.oldData as StandardReference;

            if (stdRef) {
                let updatedStandardReference = { ...stdRef, ...e.newData };
                updateStandardReference(updatedStandardReference)
                    .then(() => {
                        showToast("USP Standard reference updated", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating USP Standard Reference");
                    });
            }
        }
        else {
            if (e.newData) {
                let stdRef = e.newData as StandardReference;

                if (stdRef) {
                    await insertStandardReference(stdRef)
                        .then(data => {
                            showToast("USP Standard reference saved", "success");
                            getStandardReferencesByManufacturerId(ManufacturerTypes.USP);
                        })
                        .catch((res) => {
                            showMessage(res, ModalMessageType.Error, "Error Inserting USP Standard Reference");
                        });
                }
            }
        }
    }

    async function onEpStandardReferenceValidating(e: any) {
        if (e.oldData) {
            let stdRef = e.oldData as StandardReference;

            if (stdRef) {
                let updatedStandardReference = { ...stdRef, ...e.newData };
                updateStandardReference(updatedStandardReference)
                    .then(() => {
                        showToast("EP Standard reference updated", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating EP Standard Reference");
                    });
            }
        }
        else {
            if (e.newData) {
                let stdRef = e.newData as StandardReference;

                if (stdRef) {
                    await insertStandardReference(stdRef)
                        .then(data => {
                            showToast("EP Standard reference saved", "success");
                            getStandardReferencesByManufacturerId(ManufacturerTypes.EP);
                        })
                        .catch((res) => {
                            showMessage(res, ModalMessageType.Error, "Error Inserting EP Standard Reference");
                        });
                }
            }
        }
    }

    async function onStandardReferencePreviousLotValidating(e: any) {
        /*
        if (e.oldData) {
            let stdRef = e.oldData as StandardReference;

            if (stdRef) {
                let updatedStandardReference = { ...stdRef, ...e.newData };
                updateStandardReference(updatedStandardReference)
                    .then(() => {
                        showToast("EP Standard reference updated", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating EP Standard Reference");
                    });
            }
        }
        else {
            if (e.newData) {
                let stdRef = e.newData as StandardReference;

                if (stdRef) {
                    await insertStandardReference(stdRef)
                        .then(data => {
                            showToast("EP Standard reference saved", "success");
                            getStandardReferencesByManufacturerId(ManufacturerTypes.EP);
                        })
                        .catch((res) => {
                            showMessage(res, ModalMessageType.Error, "Error Inserting EP Standard Reference");
                        });
                }
            }
        }
        */
    }

    async function onUspStandardReferencePreviousLotValidating(e: any) {
        /*
        if (e.oldData) {
            let stdRef = e.oldData as StandardReference;

            if (stdRef) {
                let updatedStandardReference = { ...stdRef, ...e.newData };
                updateStandardReference(updatedStandardReference)
                    .then(() => {
                        showToast("EP Standard reference updated", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating EP Standard Reference");
                    });
            }
        }
        else {
            if (e.newData) {
                let stdRef = e.newData as StandardReference;

                if (stdRef) {
                    await insertStandardReference(stdRef)
                        .then(data => {
                            showToast("EP Standard reference saved", "success");
                            getStandardReferencesByManufacturerId(ManufacturerTypes.EP);
                        })
                        .catch((res) => {
                            showMessage(res, ModalMessageType.Error, "Error Inserting EP Standard Reference");
                        });
                }
            }
        }
        */
    }

    async function onEpStandardReferencePreviousLotValidating(e: any) {
        /*
        if (e.oldData) {
            let stdRef = e.oldData as StandardReference;

            if (stdRef) {
                let updatedStandardReference = { ...stdRef, ...e.newData };
                updateStandardReference(updatedStandardReference)
                    .then(() => {
                        showToast("EP Standard reference updated", "success");
                    })
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating EP Standard Reference");
                    });
            }
        }
        else {
            if (e.newData) {
                let stdRef = e.newData as StandardReference;

                if (stdRef) {
                    await insertStandardReference(stdRef)
                        .then(data => {
                            showToast("EP Standard reference saved", "success");
                            getStandardReferencesByManufacturerId(ManufacturerTypes.EP);
                        })
                        .catch((res) => {
                            showMessage(res, ModalMessageType.Error, "Error Inserting EP Standard Reference");
                        });
                }
            }
        }
        */
    }


    async function onStandardReferenceRowDeleting(e: any) {
        let standardId = e.data.standardId;

        if (standardId)
            await deleteStandardReference(standardId)
                .then(data => {
                    showToast("Standard reference deleted", "success");
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Deleting Standard Reference");
                });
    }

    async function onStandardReferencePreviousLotRowDeleting(e: any) {
        /*
        let standardId = e.data.standardId;

        if (standardId)
            await deleteStandardReference(standardId)
                .then(data => {
                    showToast("Standard reference deleted", "success");
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Deleting Standard Reference");
                });
                */
    }

    async function onUspStandardReferencePreviousLotRowDeleting(e: any) {
        /*
        let standardId = e.data.standardId;

        if (standardId)
            await deleteStandardReference(standardId)
                .then(data => {
                    showToast("Standard reference deleted", "success");
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Deleting Standard Reference");
                });
                */
    }

    async function onEpStandardReferencePreviousLotRowDeleting(e: any) {
        /*
        let standardId = e.data.standardId;

        if (standardId)
            await deleteStandardReference(standardId)
                .then(data => {
                    showToast("Standard reference deleted", "success");
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Deleting Standard Reference");
                });
                */
    }

    function catalogReferenceCellRender(e: any) {
        let coaUrl = "NA";

        if (e.data && e.data.manufacturerId && e.data.catalogNumber && e.data.lotNumber) {

            switch (e.data.manufacturerId) {
                case ManufacturerTypes.EP:
                    coaUrl = `https://crs.edqm.eu/db/4DCGI/View=${e.data.catalogNumber}`
                    break;
                case ManufacturerTypes.BP:
                    coaUrl = ``
                    break;
                case ManufacturerTypes.ACUS:
                    coaUrl = `https://docs.accustandard.com/docshare/coa/COA_${e.data.catalogNumber}_${e.data.lotNumber}.pdf`
                    break;
                case ManufacturerTypes.ABUS:
                    coaUrl = `https://www.absolutestandards.com/coa/20000/Part${e.data.catalogNumber}-Lot${e.data.lotNumber}.pdf`
                    break;
                case ManufacturerTypes.IOVS:
                    coaUrl = `https://www.inorganicventures.com/coa/Letterhead/IV/${e.data.catalogNumber}_${e.data.lotNumber}.pdf`
                    break;
                case ManufacturerTypes.RTKS:
                    coaUrl = `https://www.restek.com/api/documentaccess/get/refstdCert/${e.data.catalogNumber}/${e.data.lotNumber}.pdf`
                    break;
                case ManufacturerTypes.SGAS:
                    coaUrl = `https://www.sigmaaldrich.com/certificates/sapfs/PROD/sap/certificate_pdfs/COFA/Q14/${e.data.catalogNumber}-BULK${e.data.lotNumber}.pdf`
                    break;
                case ManufacturerTypes.USP:
                    coaUrl = `https://static.usp.org/pdf/EN/referenceStandards/certificates/${e.data.catalogNumber}-${e.data.lotNumber}.pdf`
                    break;
            }
        }

        if (coaUrl !== "NA")
            return <a href={coaUrl} rel="noopener noreferrer" target="_blank">C of A</a>;
        else
            return <div>NA</div>;
    }

    async function filterDataFromUrl() {
        if (filteredDataComplete)
            return;

        if (standardId) {
            await getStandardReferenceByStandardId(standardId)
                .then((data) => {
                    setFilteredDataComplete(true);

                    if (data.manufacturerId) {
                        if (data.manufacturerId === ManufacturerTypes.USP) {
                            const mainPanelButton = document.getElementById("uspPanelButton") as HTMLButtonElement;
                            mainPanelButton.click();

                            let filteredUspRefStandards: StandardReference[] = [];
                            filteredUspRefStandards.push(data);

                            setUspRefStandards(filteredUspRefStandards);
                        }
                        else if (data.manufacturerId === ManufacturerTypes.EP) {
                            const mainPanelButton = document.getElementById("epPanelButton") as HTMLButtonElement;
                            mainPanelButton.click();

                            let filteredEpRefStandards: StandardReference[] = [];
                            filteredEpRefStandards.push(data);

                            setEpRefStandards(filteredEpRefStandards);
                        }
                        else {
                            const mainPanelButton = document.getElementById("mainPanelButton") as HTMLButtonElement;
                            mainPanelButton.click();

                            let filteredRefStandards: StandardReference[] = [];
                            filteredRefStandards.push(data);

                            setStandardReferences(filteredRefStandards);
                        }
                    }
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Previous Lots");
                });
        }
    }

    function onParseCofAClick() {
        console.log("onParseCofAClick::");
        console.log(selectedStandardManufacturer);

        if (selectedStandardManufacturer && catalogNumberFilter && lotNumberFilter)
            parseCofA(selectedStandardManufacturer.id, catalogNumberFilter, lotNumberFilter)
    }

    async function parseCofA(manufacturer: ManufacturerTypes, catalogNumber: string, lotNumber: string) {
        console.log("parseCofA....")
        console.log({ manufacturer: manufacturer, catalogNumber: catalogNumber, lotNumber: lotNumber });

        await CrudFunctions.getData(`standards/parsecofa/${manufacturer}/${catalogNumber}/${lotNumber}`)
            .then(data => {
                console.log("parseCofA:");
                console.log(data);

                setImportedStandardReference(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Parsing C of A");
            });
    }

    async function getStandardsManufacturers() {
        await CrudFunctions.getData("standards/standardsmanufacturers")
            .then(data => {
                let manufacturers = data as LookupItem[];

                if (manufacturers) {
                    //removing USP and EP 
                    manufacturers.splice(manufacturers.findIndex(m => m.id === ManufacturerTypes.EP), 1);
                    manufacturers.splice(manufacturers.findIndex(m => m.id === ManufacturerTypes.USP), 1);

                    setStandardManufacturers(manufacturers);
                }
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Standard Reference");
            });
    }

    async function getStandardReferencesByManufacturerId(manufacturerId: number) {
        await CrudFunctions.getData(`standards/standardreferencesbymanufacturerid/${manufacturerId}`)
            .then(data => {
                if (manufacturerId === ManufacturerTypes.USP)
                    setUspRefStandards(data);
                else if (manufacturerId === ManufacturerTypes.EP)
                    setEpRefStandards(data);
                else
                    setStandardReferences(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Manufacturers");
            });
    }

    async function getStandardReferencePreviousLotsByStandardId(standardId: string, manufacturerId: number) {
        await CrudFunctions.getData(`standards/previouslotsbystandardid/${standardId}`)
            .then(data => {
                if (manufacturerId === ManufacturerTypes.USP)
                    setUspRefStandardPreviousLots(data);
                else if (manufacturerId === ManufacturerTypes.EP)
                    setEpRefStandardPreviousLots(data);
                else
                    setStandardReferencePreviousLots(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Previous Lots");
            });
    }

    async function getStandardReferenceByStandardId(standardId: string) {
        return await CrudFunctions.getData(`standards/standardreferencebystandardid/${standardId}`)
    }

    async function insertStandardReference(newStandardReference: StandardReference) {
        return await CrudFunctions.postData("standards/refstandard", newStandardReference);
    }

    /*
    async function importExcelStandardsReferenceFile(document: Document) {
        await CrudFunctions.postData("standards/importstandardreferences", document)
            .then(() => {
                if (selectedStandardManufacturer)
                    getStandardReferencesByManufacturerId(selectedStandardManufacturer.id);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Importing Standards");
            });
    }
    */


    async function updateStandardReference(updatedStandardReference: StandardReference) {
        return await CrudFunctions.putData("standards/refstandard", updatedStandardReference);
    }

    async function deleteStandardReference(standardId: string) {
        return await CrudFunctions.deleteData(`standardreference/${standardId}`)
    }

    /*
    async function onFileLoaderChange(e: any) {
        let files = e.target.files;

        if (files && files.length > 0) {
            let file = files[0];

            let doc: Document = {
                name: file.name,
                kbSize: file.size,
                mimeTypeString: file.type
            };

            var reader = new FileReader();

            reader.onload = (event: any) => readFile(doc, event)
                .then((doc) => {
                    importExcelStandardsReferenceFile(doc);
                });

            reader.readAsBinaryString(file);
        }
    }

    async function readFile(doc: Document, event: any): Promise<any> {
        if (event && event.target && event.target.result) {
            let binaryString = event.target.result;
            let documentData = btoa(binaryString);

            doc.base64Blob = documentData;
            return doc;
        }
    }
    */
    function showStandardReferenceAuditDialog(e: any) {
        if (e.row && e.row.data) {
            const auditParams: AuditProps = {
                entity: Entities.RawMaterials,
                rowPointer: e.row.data.rawMaterialId,
                informationShowChildData: false,
            };

            setAuditProps(auditParams);
            setAuditInformationDialogVisible(true);
        }
    }

    function onStandardReferenceInformationButtonClicked(e: any) {
        if (e.row && e.row.data) {
            let itemBasicInformation: ItemBasicInformation = {
                rowPointer: e.row.data.standardId,
                createTimestamp: e.row.data.createTimestamp,
                lastModifiedTimestamp: e.row.data.modifyTimestamp,
                createUser: e.row.data.createUser,
                modifyUser: e.row.data.modifyUser
            };

            setItemBasicInformation(itemBasicInformation);
            setItemBasicInformationDialogVisible(true);
        }
    }

    //show/hide

    function onToastHiding() {
        let toastParams: ToastProps = {
            message: undefined,
            toastType: undefined,
            visible: false
        };

        setToastProps(toastParams);
    }

    function showToast(message: string, toastType: string) {
        let toastParams: ToastProps = {
            message: message,
            toastType: toastType,
            visible: true
        };

        setToastProps(toastParams);
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    function hideAuditInformationDialog() {
        setAuditInformationDialogVisible(false);
    }

    function showTicketLogEntryDialog() {
        setTicketLogEntryDialogVisible(true);
    }

    function hideTicketLogEntryDialog() {
        setTicketLogEntryDialogVisible(false);
    }

    // Other methods

    function onPanelButtonClick(e: any) {
        resetAllButtons();

        const button = e.target as HTMLDivElement;

        if (button) {
            button.className = "tab-button-active";
        }

        hideAllComponents();

        const id: string = e.target.id;

        const panel = document.getElementById(id.replace("Button", "")) as HTMLDivElement;
        panel.style.display = "";
    }

    function resetAllButtons() {
        const mainPanelButton = document.getElementById("mainPanelButton") as HTMLDivElement;
        mainPanelButton.className = "tab-button-inactive";

        const uspPanelButton = document.getElementById("uspPanelButton") as HTMLDivElement;
        uspPanelButton.className = "tab-button-inactive";

        const epPanelButton = document.getElementById("epPanelButton") as HTMLDivElement;
        epPanelButton.className = "tab-button-inactive";
    }

    function hideAllComponents(onload: boolean = false) {

        if (!onload) {
            const mainPanel = document.getElementById("mainPanel") as HTMLDivElement;
            mainPanel.style.display = "none";
        }

        const uspPanel = document.getElementById("uspPanel") as HTMLDivElement;
        uspPanel.style.display = "none";

        const epPanel = document.getElementById("epPanel") as HTMLDivElement;
        epPanel.style.display = "none";
    }


    //navigation

    function goBack() {
        history.back();
    }

    //other

    function initUiSettings() {
        hideAllComponents(true);

        const mainPanelButton = document.getElementById("mainPanelButton") as HTMLButtonElement;
        mainPanelButton.click();
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}

